module.exports = __webpack_public_path__ + "static/media/MPA-completa_2.e569de7d.png";